export const LinkedIn = () => {
  return (
    <svg viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1 4.55556C1 2.59189 2.59189 1.00001 4.55555 1.00001V1.00001H13.4444V1.00001C15.4081 1.00001 17 2.59189 17 4.55558V13.4444C17 15.4081 15.4081 17 13.4444 17V17H4.55555V17C2.59188 17 1 15.4081 1 13.4444L1 4.55556Z"
        stroke="currentColor"
      />
      <line
        x1="5.00391"
        y1="14.9851"
        x2="5.00391"
        y2="7.16289"
        stroke="currentColor"
      />
      <line
        x1="8.55957"
        y1="14.9851"
        x2="8.55957"
        y2="7.16289"
        stroke="currentColor"
      />
      <path
        d="M13.5634 14.9851C13.5634 14.9851 13.5634 11.311 13.5634 10.1258C13.5634 8.94066 12.9471 7.63696 11.4301 7.63696C8.46709 7.63696 8.58561 10.0073 8.58561 11.1925"
        stroke="currentColor"
      />
      <circle cx="5" cy="5" r="1" fill="currentColor" />
    </svg>
  )
}
